/**
 * Knowledge: the «Знання» screen (ADR-0010) — findings, funnel cases with their steps and sources,
 * and the «Знання за тиждень» block of the dashboard.
 */
export const knowledge = {
  'knowledge.title': 'Знання',
  'knowledge.intro': 'Що Офіс збирає з дзвінків, чужих воронок і відео: знахідки (болі, заперечення, фрази дослівно), воронки-кейси з кроками і джерела цілком. Агенти пишуть самі; вам лишаються лише непевні знахідки.',
  'knowledge.noAccess': 'Знання бачать ті, кому дано право їх читати.',
  'knowledge.search': 'Пошук: слово, фраза, ніша',
  'knowledge.allBusinesses': 'Усі бізнеси',
  'knowledge.notFound': 'Не знайдено',
  'knowledge.close': 'Закрити',
  'knowledge.more': 'Ще',
  'knowledge.shown': 'Показано {shown} з {total}',
  'knowledge.findings.title': 'Знахідки',
  'knowledge.findings.counts': 'Чекають вас: {proposed} · підтверджено: {confirmed}',
  'knowledge.findings.empty': 'Знахідок ще немає. Їх приносять дзвінки, розбирач Вхідної і розібрані відео.',
  'knowledge.findings.col.what': 'Що',
  'knowledge.findings.col.segment': 'Сегмент',
  'knowledge.findings.col.business': 'Бізнес',
  'knowledge.findings.col.from': 'Звідки',
  'knowledge.findings.col.status': 'Стан',
  'knowledge.findings.col.when': 'Коли',
  'knowledge.findings.fromInbox': 'з Вхідної',
  'knowledge.findings.fromLink': 'посилання',
  'knowledge.findings.confirm': 'Підтвердити',
  'knowledge.findings.reject': 'Відхилити',
  'knowledge.kind.pain': 'Біль',
  'knowledge.kind.need': 'Потреба',
  'knowledge.kind.objection': 'Заперечення',
  'knowledge.kind.quote': 'Фраза',
  'knowledge.kind.idea': 'Ідея',
  'knowledge.kind.question': 'Питання',
  'knowledge.status.proposed': 'Чекає вас',
  'knowledge.status.confirmed': 'Підтверджено',
  'knowledge.status.rejected': 'Відхилено',
  'knowledge.funnels.title': 'Воронки-кейси',
  'knowledge.funnels.empty': 'Воронок-кейсів ще немає. Розбирач робить їх зі скрінів лендингів, реклами й квізів.',
  'knowledge.funnels.col.funnel': 'Воронка',
  'knowledge.funnels.col.offer': 'Офер · ціна',
  'knowledge.funnels.col.next': 'Далі',
  'knowledge.funnels.col.steps': 'Кроків',
  'knowledge.funnels.col.status': 'Стан',
  'knowledge.funnels.col.updated': 'Оновлено',
  'knowledge.funnel.collecting': 'Збираємо кроки',
  'knowledge.funnel.complete': 'Пройдено',
  'knowledge.funnel.needs_human': 'Потрібні ви',
  'knowledge.funnel.kind': 'Воронка-кейс',
  'knowledge.funnel.niche': 'Ніша',
  'knowledge.funnel.product': 'Продукт',
  'knowledge.funnel.owner': 'Хто',
  'knowledge.funnel.entry': 'Вхід',
  'knowledge.funnel.offer': 'Офер',
  'knowledge.funnel.price': 'Ціна',
  'knowledge.funnel.next': 'Далі',
  'knowledge.funnel.design': 'Дизайн',
  'knowledge.funnel.steps': 'Кроки · {n}',
  'knowledge.funnel.noSteps': 'Кроків ще немає.',
  'knowledge.funnel.findings': 'Знахідки з цієї воронки · {n}',
  'knowledge.funnel.open': 'Відкрити сторінку',
  'knowledge.funnel.fromInbox': 'з Вхідної',
  'knowledge.sources.title': 'Джерела',
  'knowledge.sources.empty': 'Джерел ще немає. Сюди лягають транскрипти дзвінків і відео зі списку YouTube.',
  'knowledge.sources.col.source': 'Джерело',
  'knowledge.sources.col.business': 'Бізнес',
  'knowledge.sources.col.state': 'Стан',
  'knowledge.sources.col.findings': 'Знахідок',
  'knowledge.sources.col.when': 'Коли',
  'knowledge.sourceKind.call_transcript': 'Дзвінок',
  'knowledge.sourceKind.video': 'Відео',
  'knowledge.sourceKind.lesson': 'Урок',
  'knowledge.sourceKind.extract': 'Витяжка',
  'knowledge.extracts.title': 'Витяжки для агентів',
  'knowledge.extracts.hint': 'З них вчаться агенти: кожна витяжка — короткий зміст одного уроку чи документа, позначений ролями агентів.',
  'knowledge.extracts.empty': 'Витяжок ще немає. Вони з’являються, коли агент бере свої матеріали в Офіс.',
  'knowledge.extracts.col.extract': 'Витяжка',
  'knowledge.extracts.col.tags': 'Для кого',
  'knowledge.state.awaiting_transcript': 'Чекає транскрипції',
  'knowledge.state.awaiting_analysis': 'Чекає розбору',
  'knowledge.state.analyzed': 'Розібрано',
  'knowledge.source.open': 'Відкрити джерело',
  'knowledge.source.text': 'Текст',
  'knowledge.source.noText': 'Тексту ще немає: відео чекає транскрипції на Маку.',
  'knowledge.source.slice': 'Показано {from}–{to} з {length} знаків',
  'knowledge.source.nextSlice': 'Далі',
  'knowledge.source.findings': 'Знахідки з цього джерела · {n}',
  'overview.knowledge.counts': 'Знахідок {findings} (чекають вас {proposed}) · воронок-кейсів {funnels} · джерел {sources}',
  'overview.knowledge.none': 'За тиждень нового немає.',
  'overview.knowledge.funnel': 'Воронка',
  'overview.knowledge.steps': 'кроків: {n}',
} as const;
